import React from 'react'
import { View, TouchableWithoutFeedback, Modal, Platform, Dimensions } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

import PropTypes from 'prop-types'

import { VFText, VFButton, Icon } from '@vfgroup-oneplatform/foundation/Components'
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'

import { getThemeImages } from '../../Themes'

import styles from './BookingErrorModal.Styles'
import _Modal from 'react-native-modal'


const BookingErrorModal = ({
  isVisible,
  onClose,
  errorMessage,
}) => {
  const theme = useTheme()
  const themedImages = getThemeImages(theme.name)

  const insets = useSafeAreaInsets()

  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <_Modal
        isVisible={isVisible}
        backdropOpacity={0.5}
        onSwipeComplete={onClose}
        onBackdropPress={onClose}
        propagateSwipe
        hideModalContentWhileAnimating
        hardwareAccelerated
        backdropTransitionOutTiming={0}
        style={{
          justifyContent: 'flex-end',
          margin: '0 !important',
          minWidth: 1920,
          maxWidth: 1920,
        }}
      >
        <View
          style={{
            minWidth: '600px',
            maxWidth: '600px',
            height: 'auto',
            backgroundColor: theme.colors.quickActionGradientColors.secondary,
            margin: 'auto',
            padding: '20px',
            paddingTop: null,
            borderRadius: "7px",
          }}
          onStartShouldSetResponder={() => true}>
          <TouchableWithoutFeedback onPress={onClose}>
            <View style={styles.closeButtonContainer(insets)}>
              <Icon name={themedImages.TImages.ic_close.primary} size={25} />
            </View>
          </TouchableWithoutFeedback>

          <View style={styles.contentContainStyle}>
            <View style={styles.contentStyle}>
              <Icon
                name={themedImages.warning}
                size={130}
                resizeMode="contain"
              />

              <VFText
                i18nKey="book_appointment_error_title"
                style={styles.titleStyle(theme)}
              />

              <VFText
                i18nKey={errorMessage || 'book_appointment_error_message'}
                style={styles.subTitleStyle(theme)}
              />
            </View>

            <View>
              <VFButton
                title="book_appointment_go_back"
                style={styles.appointmentsButtonStyle}
                onPress={onClose}
              />
            </View>
          </View>
        </View>
      </_Modal>

    )
  }

  return (
    <Modal visible={isVisible}>
      <View style={styles.containerStyle(theme, insets)}>
        <TouchableWithoutFeedback onPress={onClose}>
          <View style={styles.closeButtonContainer(insets)}>
            <Icon name={themedImages.TImages.ic_close.primary} size={25} />
          </View>
        </TouchableWithoutFeedback>

        <View style={styles.contentContainStyle}>
          <View style={styles.contentStyle}>
            <Icon
              name={themedImages.warning}
              size={130}
              resizeMode="contain"
            />

            <VFText
              i18nKey="book_appointment_error_title"
              style={styles.titleStyle(theme)}
            />

            <VFText
              i18nKey={errorMessage || 'book_appointment_error_message'}
              style={styles.subTitleStyle(theme)}
            />
          </View>

          <View>
            <VFButton
              title="book_appointment_go_back"
              style={styles.appointmentsButtonStyle}
              onPress={onClose}
            />
          </View>
        </View>
      </View>
    </Modal>
  )
}

BookingErrorModal.propTypes = {
  isVisible: PropTypes.bool,
  onClose: PropTypes.func,
}

export default BookingErrorModal
